import React, { useEffect } from 'react';

import styled, { css } from 'styled-components';

import {
  SortDropdown as BaseSortDropdown,
  desktop,
  mobile,
  useProductBrowser,
} from '~/techstyle-shared/react-components';

import { useProductBrowserFilterState } from '../ProductBrowserFilterContext';

const GridSortDropdown = styled(BaseSortDropdown)`
  font-size: 14px;
  font-family: ${({ theme }) => theme.fontStacks.textFamily};

  ${desktop`
    margin-left: auto;
  `}
`;

const buttonStyle = css`
  color: ${({ theme }) => theme.colors.textDefault};
  &[data-expanded='true'] {
    background-color: ${({ theme }) => theme.colors.palette.white};
    color: ${({ theme }) => theme.colors.textDefault};
  }
`;

const activeSelectionStyle = css`
  color: ${({ theme }) => theme.colors.sortActiveSelection};

  padding-right: 23px;
  &[data-expanded='true'] {
    color: ${({ theme }) => theme.colors.sortActiveSelection};
  }
  ${mobile`
    padding-right: 4px;
  `}

  ${({ theme }) => theme.gridStyles.sortActiveSelectionStyle};
`;

const dropdownListStyle = css`
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.colors.sortDropdownListBorder};
  ${mobile`
    padding: 8px;
    width: 100vw;
  `}
`;

const dropdownListItemStyle = css`
  font-size: 14px;
  border-top: none;

  &[aria-current='true'] {
    background-color: ${({ theme }) => theme.colors.palette.white};
    color: ${({ theme }) => theme.colors.focusText};
  }

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.textEmphasized};
    background-color: ${({ theme: { colors } }) =>
      colors.sortDropdownListItemBgHover};
  }

  ${mobile`
    font-size: 16px;
  `}
`;

const buttonListWrapperStyle = css`
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.colors.sortDropdownBtnListBorder};
  ${mobile`
    border: none;
  `}
`;

const desktopLabelStyle = css`
  ${mobile`
    display: none;
  `}

  ${({ theme }) => theme.gridStyles.desktopSortLabelStyle};
`;

const mobileLabelStyle = css`
  color: ${({ theme }) => theme.colors.textDefault};
  ${({ theme }) => theme.gridStyles.sortLabel};

  font-weight: 600;
  ${desktop`
    display: none;
  `}
`;

function SortDropdown(props) {
  const { openOverlay, closeOverlay, sort } = useProductBrowser();
  const sharedFilterState = useProductBrowserFilterState();

  useEffect(() => {
    if (sharedFilterState && sharedFilterState.sort !== sort) {
      sharedFilterState.setSort(sort);
    }
  }, [sharedFilterState, sort]);

  return (
    <GridSortDropdown
      buttonStyle={buttonStyle}
      activeSelectionStyle={activeSelectionStyle}
      dropdownListStyle={dropdownListStyle}
      dropdownListItemStyle={dropdownListItemStyle}
      buttonListWrapperStyle={buttonListWrapperStyle}
      desktopLabelStyle={desktopLabelStyle}
      mobileLabelStyle={mobileLabelStyle}
      onOpen={openOverlay}
      onClose={closeOverlay}
      {...props}
    />
  );
}

export default SortDropdown;
